export const SUBMISSION_ENDPOINTS = {
  submit: "/submission/submit",
  bundles: "/api/submission/bundles",
};
